export default "__VITE_ASSET__fad23867__"